export const GET_AREA_COVERAGE_REQUEST = 'GET_AREA_COVERAGE_REQUEST';
export const GET_AREA_COVERAGE_SUCCESS = 'GET_AREA_COVERAGE_SUCCESS';
export const GET_AREA_COVERAGE_FAILURE = 'GET_AREA_COVERAGE_FAILURE';
export const GET_COUNTIES_REQUEST = 'GET_COUNTIES_REQUEST';
export const GET_COUNTIES_SUCCESS = 'GET_COUNTIES_SUCCESS';
export const GET_COUNTIES_FAILURE = 'GET_COUNTIES_FAILURE';
export const ADD_AREA_COVERAGE_REQUEST = 'ADD_AREA_COVERAGE_REQUEST';
export const ADD_AREA_COVERAGE_SUCCESS = 'ADD_AREA_COVERAGE_SUCCESS';
export const ADD_AREA_COVERAGE_FAILURE = 'ADD_AREA_COVERAGE_FAILURE';
export const DELETE_AREA_COVERAGE_REQUEST = 'DELETE_AREA_COVERAGE_REQUEST';
export const DELETE_AREA_COVERAGE_SUCCESS = 'DELETE_AREA_COVERAGE_SUCCESS';
export const DELETE_AREA_COVERAGE_FAILURE = 'DELETE_AREA_COVERAGE_FAILURE';
export const UPDATE_AREA_COVERAGE_REQUEST = 'UPDATE_AREA_COVERAGE_REQUEST';
export const UPDATE_AREA_COVERAGE_SUCCESS = 'UPDATE_AREA_COVERAGE_SUCCESS';
export const UPDATE_AREA_COVERAGE_FAILURE = 'UPDATE_AREA_COVERAGE_FAILURE';
export const TOGGLLE_EDIT_MODE = 'TOGGLLE_EDIT_MODE';
export const TOGGLE_ADD_NEW_ZONE = 'TOGGLE_ADD_NEW_ZONE';
export const RESET_COUNTIES_LIST = 'RESET_COUNTIES_LIST';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_COMPANY_INFO = 'SET_COMPANY_INFO';
export const GET_COVERAGE_STATE_REQUEST = 'GET_COVERAGE_STATE_REQUEST';
export const GET_COVERAGE_STATE_SUCCESS = 'GET_COVERAGE_STATE_SUCCESS';
export const GET_STATE_COUNTIES_SUCCESS = 'GET_STATE_COUNTIES_SUCCESS';
export const GET_STATE_COUNTIES_FAILURE = 'GET_STATE_COUNTIES_FAILURE';
